/**
 * tabs v1.0.2
 */

import Component from '../../js/lib/component';

import $ from 'jquery';
import anime from 'animejs';

const classList = {
  root: '[data-tooltip]'
};

export default class Tooltip extends Component {
  init() {
    this.$.root = $(classList.root);
  }
  events() {
    this.$.root.on('mouseenter', e => {
      const $target = $(e.currentTarget);
      let $tooltip;

      this.timer = setTimeout(() => {
        const position = $target.offset();
        const textContent = $target.data('tooltip');

        $tooltip = this.render(textContent);

        anime.set($tooltip.get(), {
          translateY: 10,
          opacity: 0
        });

        this.$.body.append($tooltip);

        const tooltip = {
          height: $tooltip.height(),
          width: $tooltip.outerWidth()
        };

        const target = {
          height: $target.height(),
          width: $target.width()
        };

        anime.set($tooltip.get(), {
          left: position.left + target.width / 2 - tooltip.width / 2 + 2,
          top: position.top - tooltip.height - target.height - 5
        });

        anime({
          targets: $tooltip.get(),
          duration: 250,
          easing: 'easeOutCubic',
          opacity: 1,
          translateY: 0
        });
      }, 400);

      $target.one('mouseleave', () => {
        clearTimeout(this.timer);

        if ($tooltip) {
          anime({
            targets: $tooltip.get(),
            duration: 250,
            easing: 'easeInCubic',
            opacity: 0,
            translateY: 10,
            complete: () => {
              $tooltip.remove();
            }
          });
        }
      });
    });
  }
  render(textContent) {
    return $(`<div class='tooltip'>${textContent}</div>`);
  }
}

Component.mount(Tooltip, {
  name: 'Tooltip',
  state: {},
  classList,
  singleton: true
});
